import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface SummaryDetail {
  icon: string; // Emoji or Material Icon name
  labelKey: string; // Translation key
  value: any;
}

export interface SummaryModalData {
  titleKey: string;
  subtitleKey: string;
  details: SummaryDetail[];
}

@Component({
  selector: 'app-summary-modal',
  templateUrl: './summary-modal.component.html',
  styleUrls: ['./summary-modal.component.scss']
})
export class SummaryModalComponent implements OnInit {
  position = 0;
  confirmed = false;
  maxSwipe = 323;
  dragging = false;
  lastX = 0;
  titleKey: string;
  subtitleKey: string;
  details: SummaryDetail[];
  @ViewChild('swipeContainer') swipeContainer!: ElementRef; 
  constructor(
    public dialogRef: MatDialogRef<SummaryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SummaryModalData,
    public translate: TranslateService
  ) {
    this.titleKey = data.titleKey;
    this.subtitleKey = data.subtitleKey;
    this.details = data.details;
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maxSwipe = this.swipeContainer.nativeElement.offsetWidth - 50;
    });
  }
  startDrag(event: MouseEvent | TouchEvent) {
    if (this.confirmed) return;
    this.dragging = true;
    this.lastX = this.getEventX(event);
  }

  drag(event: MouseEvent | TouchEvent) {
    if (!this.dragging || this.confirmed) return;
    const currentX = this.getEventX(event);
    const deltaX = currentX - this.lastX;
    this.position = Math.min(Math.max(this.position + deltaX, 0), this.maxSwipe);
    this.lastX = currentX;
  }

  endDrag() {
    if (this.position >= this.maxSwipe) {
      this.confirmed = true;
      this.dialogRef.close(true);
    }
    this.dragging = false;
  }
    submit(){
    this.confirmed = true;
    this.dialogRef.close(true);
  }


  private getEventX(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
  }

    cancel() {
    this.dialogRef.close(false);
  }
}
